import React, {memo} from "react";
import {Modal} from "react-bootstrap";
import {useSelector} from "react-redux";
import ListProductsFooter from "./listProducts/ListProductsFooter";
import PostScheduleFooter from "./postSchedule/PostScheduleFooter";
import QuestionsFooter from "./questions/QuestionsFooter";
import InvoiceFooter from "./invoice/InvoiceFooter";

const FooterModalShoppingCard = () => {
    const {levelPayment} = useSelector(state => state.modalShoppingCard);
    const handelPagesLevelsShoppingCard = () => {
        switch (levelPayment) {
            case 'LIST_PRODUCTS':
                return <ListProductsFooter/>;
            case 'POST_SCHEDULE':
                return <PostScheduleFooter/>;
            case 'QUESTIONS':
                return <QuestionsFooter/>;
            case 'INVOICE':
                return <InvoiceFooter/>;
            default:
                return <div>notFind</div>;
        }
    };
    return (
        <Modal.Footer>
            {handelPagesLevelsShoppingCard()}
        </Modal.Footer>
    );
};

export default memo(FooterModalShoppingCard);